"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSrcArtifactSlug = exports.newOperationNode = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const registry_1 = require("../registry");
// A new operation node, with a fresh id, holding `configuration`.
const newOperationNode = (nodeType, configuration) => ({
    metadata: {
        tapeBuilderNodeId: (0, uuid_1.v4)(),
        tapeBuilderNodeType: nodeType,
    },
    configuration,
});
exports.newOperationNode = newOperationNode;
// The artifact slug of an operation's source node, which must be a tape node.
const getSrcArtifactSlug = (srcNode, isOperationMessage = 'src node is an operation node') => {
    const uiNode = (0, registry_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
    (0, common_1.finleyAssert)(!uiNode.isOperation, isOperationMessage);
    return (0, tape_builder_base_1.asArtifactSlugRef)(uiNode.getArtifactSlug(srcNode));
};
exports.getSrcArtifactSlug = getSrcArtifactSlug;
//# sourceMappingURL=converterUtils.js.map